import { useTranslation } from 'react-i18next'

export const useReportingTableLabelsMap = () => {
    const { t } = useTranslation('translations')

    return {
        name: t('reporting_table.reportName'),
        owner: t('reporting_table.owner'),
        updatedAt: t('reporting_table.lastUpdate'),
    }
}

export type ReportingTableLabelsMap = {
    name: string
    owner: string
    updatedAt: string
}
